import {
  CLIENT_CONDITION_VARIATION,
  CLIENT_INIT_DATUM,
  CLIENT_PAGINATION_VARIATION,
  CLIENT_PAGINATION_VARIATION_THERE_ARE_DATA,
  CLIENT_REQUSET_PARAM, CLIENT_RESET_CONTENT, CLIENT_TRANSFER
} from "./type";
import axios from '../../axios/axios';
import ipAddress from "../../axios/ipAddress";

const client = {
  state: () => ({
    key: '',
    datumStatus: '',
    roleId: '',
    source:'',
    startDt: '',
    endDt: '',
    departmentKey: '',
    remark: '',
    current: 1,
    size: 12,
    clients: [],
    pages: 0,
    sorts: [
      {
        sortColumn: 'id',
        sortType: 'DESC',
      }
    ],
    total: 0
  }),

  namespaced: true,

  mutations: {
    //第一次初始化
    [CLIENT_INIT_DATUM]: (state, payload) => {
      state.pages = payload.pages;
      state.total = payload.total;
      state.clients = [
        {
          page: 1,
          client: payload.list
        }
      ]
    },
    //客户列表页数发生变化，无数据
    [CLIENT_PAGINATION_VARIATION]: (state, payload) => {
      state.pages = payload.pages;
      state.total = payload.total;
      const page = payload.page;
      state.current = page;
      state.clients = [
        ...state.clients,
        { page: page,
          client: payload.list}
      ]
    },
    //客户列表页数发生变化，存在数据
    [CLIENT_PAGINATION_VARIATION_THERE_ARE_DATA]:(state, page) =>{
      state.current = page
    },
    //修改请求参数
    [CLIENT_REQUSET_PARAM]:(state,payload)=>{
      const type = payload.type
      const content = payload.content
      switch(type){
        case 1:  //姓名/手机号
           state.key = content
          break;
        case 2:  //备注
           state.remark = content
          break;
        case 3:  //审核状态
           state.datumStatus = content
          break;
        case 4:   //会员类型
          state.roleId = content
          break;
        case 5:  //部门(员工)名/编号
          state.departmentKey = content
          break;
        case 6: //开始时间和结束时间
          state.startDt = `${content[0]} 00:00:00`
          state.endDt = `${content[1]} 23:59:59`
          break;
        case 7: //客户类型
          state.source = content
          break;
        default:
      }
    },
    //重置内容
    [CLIENT_RESET_CONTENT]:(state)=>{
      state.key = ''
      state.remark = ''
      state.datumStatus = ''
      state.roleId = ''
      state.source = ''
      state.startDt = ''
      state.endDt = ''
      state.departmentKey = ''
      state.current = 1
    },
    //条件内容变化，重置页数，重新请求数据
    [CLIENT_CONDITION_VARIATION]:(state)=>{
      state.current = 1
    },
    //客户信息转移列表更改
    [CLIENT_TRANSFER]:(state,payload)=>{
      const BOTID = payload.BOTID
      const info = payload.info
      const clients = state.clients
      const [clientSol] = clients.filter(el => el.page == state.current)
      let client = clientSol.client.map(el =>{
          return {...el,staffName:el.id === BOTID ? info.name : el.staffName,
            departmentName:el.id === BOTID ? info.departmentName : el.departmentName
          }
        })
      state.clients = clients.map(el => {
        return el.page == state.current ? {...clientSol,client:client} : el
      })
    }
  },
  actions: {
    //第一次初始化
    [CLIENT_INIT_DATUM]: ({commit, state},isInit) => {
      const [client] = state.clients.filter(el => el.page == state.current)
      if(!isInit || !client){
        gainPagClients(commit,state)
      }
      // if(isInit){
      //
      //   if(!client){
      //
      //   }
      // }else {
      //   gainPagClients(commit,state)
      // }
    },
    //客户列表页数发生变化
    [CLIENT_PAGINATION_VARIATION]: ({commit, state}, page) => {
      const clients = state.clients
      const [clientPag] = clients.filter(el => el.page == page)
      if (!clientPag) {  //说明该页不存在数据，服务器请求新数据
        let params = parameter(state)
        params = {...params, current: page}
        axios.post(`${ipAddress.qi}/admin/a1/customer/page`, params, true).then(value => {
          const success = value.success
          if (success) {
            const content = value.content
            commit(CLIENT_PAGINATION_VARIATION, {
              list: content.records,
              pages: content.pages,
              total: content.total,
              page: page
            })
          }
        })
      }else {
        //该页数存在内容，就改变当前页数
          commit(CLIENT_PAGINATION_VARIATION_THERE_ARE_DATA,page)
      }
    },
    //重置内容
    [CLIENT_RESET_CONTENT]:({commit,dispatch})=>{
      commit(CLIENT_RESET_CONTENT)
      dispatch(CLIENT_INIT_DATUM);
    },
    //条件内容变化，重置页数，重新请求数据
    [CLIENT_CONDITION_VARIATION]:({commit,dispatch})=>{
      commit(CLIENT_CONDITION_VARIATION)
      dispatch(CLIENT_INIT_DATUM)
    }
  },
  getters: {
    getGlobalParam: state => {
      return state
    },
    //根据页数获取列表信息
    getPagCients: state => {
      const clients = state.clients
      if (clients && clients.length > 0) {
        const [clientSol] = clients.filter(el => el.page == state.current)
        if (clientSol) {

          return clientSol.client
        } else {
          return []
        }
      }
    }
  }
}


//请求参数

function parameter(state) {
  let condition = {}
  if (state.key) {
    condition = {...state, key: state.key}
  }
  if (state.datumStatus) {
    condition = {...state, datumStatus: state.datumStatus}
  }
  if (state.roleId) {
    condition = {...condition, roleId: state.roleId}
  }
  if(state.source){
    condition = {...condition, source: state.source}
  }
  if (state.startDt) {
    condition = {...condition, startDt: state.startDt}
  }
  if (state.endDt) {
    condition = {...condition, endDt: state.endDt}
  }
  if (state.departmentKey) {
    condition = {...condition, departmentKey: state.departmentKey}
  }
  if (state.remark) {
    condition = {...condition, remark: state.remark}
  }
  let params = {
    condition: condition,
    current: state.current,
    size: state.size,
    sorts: state.sorts,
  }
  return params
}


//获取该页数据
function gainPagClients(commit,state) {
  const params = parameter(state)
  console.log(params)
  axios.post(`${ipAddress.qi}/admin/a1/customer/page`, params, true).then(value => {
    const success = value.success
    if (success) {
      const content = value.content
      commit(CLIENT_INIT_DATUM, {
        list: content.records,
        pages: content.pages,
        total: content.total
      })
    }
  })
}

export default client



// WEBPACK FOOTER //
// ./src/vuex/client/index.js